export const EXTERNAL_LINKS = {
	LANDING_PORTAL: "https://tmis-skills.optimusfoxdev.com/",
} as const;

export const BROWSER_ROUTES = {
	// Auth routes
	LOGIN: "/sign-in",
	SIGNUP_VERIFY_OTP: "/sign-up/verify-otp",
	SIGNUP_RESET_PASSWORD: "/sign-up/reset-password",
	VERIFY_EMAIL: "/verify-email",
	FORGET_PASSWORD: "/forget-password",
	VERIFY_OTP: "/verify-otp",
	RESET_PASSWORD: "/reset-password",
	SET_PASSWORD: "/set-password/:id",
	UNAUTHORIZED: "/unauthorized",
	SERVER_ERROR: "/500",
	NOT_FOUND: "/404",
	ABOUT: "/about",
	// Legal routes
	PRIVACY_POLICY: "/privacy-policy",
	TERMS_AND_CONDITIONS: "/terms-and-conditions",
	// Dashboard routes
	DASHBOARD: "/",
	// Sidebar menu routes
	HISTORY: "/history",
	VERIFY_APPLICATION: "/verify-application/:applicationId",
	VERIFY_APPLICATION_CONVENER: "/verify-application/convener/:applicationId",
	VERIFY_APPLICATION_MEMBER: "/verify-application/member/:applicationId",
	ALL_LABS_WITH_INSPECTION: "/inspection/all-labs/:applicationId/:committeeId",

	// New Convener Inspection route (step-based API)
	// applicationId = application UUID, committeeId = committee UUID
	CONVENER_INSPECTION: "/convener-inspection/:applicationId/:committeeId",

	// Application routes
	APPLICATIONS_SCRUTINIZED: "/applications/scrutinized",
} as const;
